interface ImageAttributionInput {
  credit?: string | null;
  copyright?: {
    license?: string | null;
    licenseUrl?: string | null;
    creditUrl?: string | null;
  } | null;
}

const escapeHtml = (value: string): string =>
  value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

const toSafeHttpUrl = (value?: string | null): string | null => {
  if (!value) return null;
  try {
    const parsed = new URL(value);
    if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
      return null;
    }
    return parsed.toString();
  } catch {
    return null;
  }
};

const buildExternalLink = (href: string, label: string): string =>
  `<a href="${escapeHtml(href)}" target="_blank" rel="noreferrer">${escapeHtml(label)}</a>`;

export const resolvePrimaryImageAttribution = ({
  credit,
  copyright,
}: ImageAttributionInput): string | undefined => {
  if (copyright) {
    const parts: string[] = [];
    const safeLicenseUrl = toSafeHttpUrl(copyright.licenseUrl);
    const safeCreditUrl = toSafeHttpUrl(copyright.creditUrl);

    if (copyright.license) {
      parts.push(
        safeLicenseUrl
          ? buildExternalLink(safeLicenseUrl, copyright.license)
          : escapeHtml(copyright.license)
      );
    } else if (safeLicenseUrl) {
      parts.push(buildExternalLink(safeLicenseUrl, safeLicenseUrl));
    }

    if (safeCreditUrl) {
      parts.push(buildExternalLink(safeCreditUrl, 'Source'));
    }

    if (parts.length > 0) {
      return parts.join(' | ');
    }
  }

  return credit ?? undefined;
};
